export default function LogoShell() {
  return (
    <svg
      width="36"
      height="32"
      viewBox="0 0 57 52"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.1022 50.5487C25.1022 50.5487 26.1317 51.8333 28.1344 51.8333C30.1383 51.8333 31.1678 50.5487 31.1678 50.5487C32.8139 50.4784 45.6776 50.5135 45.6776 50.5135L46.9306 40.1142C46.9306 40.1142 54.8538 34.6206 55.4979 33.9869C59.3013 17.0139 45.5541 0.833344 28.1348 0.833344C10.716 0.833344 -3.03128 17.0135 0.772069 33.9869C1.41579 34.621 9.33939 40.1142 9.33939 40.1142L10.5915 50.5135C10.5915 50.5135 23.4561 50.4784 25.1022 50.5487ZM26.9374 6.00039L28.1529 36.0183L29.3478 6.00039C30.8139 5.70602 34.5536 6.05927 36.5579 7.53073L30.7235 36.1361L38.6816 8.70823C40.589 8.68536 44.4389 11.8587 44.7248 12.799L33.1171 37.137L46.1608 14.888C47.4469 15.359 50.2595 20.4503 49.8109 21.042L35.2713 38.5491L50.2298 23.599C50.2298 23.599 52.1743 26.5127 50.9058 31.4477L42.4569 37.45L41.399 45.6502H31.0396C31.0396 45.6502 29.3448 47.2305 28.1426 47.2305C26.94 47.2305 25.2452 45.6497 25.2452 45.6497H14.8862L13.8283 37.4496L5.37893 31.4477C4.11086 26.5127 6.05538 23.599 6.05538 23.599L21.0138 38.5491L6.47434 21.0416C6.02567 20.4498 8.83781 15.3586 10.124 14.8876L23.1681 37.1361L11.56 12.7982C11.8463 11.8574 15.6957 8.68451 17.6036 8.70739L25.5608 36.1361L19.7277 7.53073C21.7316 6.05927 25.4717 5.70602 26.9374 6.00039Z"
        fill="currentColor"
      />
    </svg>
  );
}
